"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Address from "../../components/address";
import Api from "../../api/api";
import DebtorTypeAhead from "../debtor_typeahead";
import FactorBrokersService from "../factor_brokers_service";
import FactorInvoicesService from "../factor_invoices_service";
import FactorInvoicesStore from "../../stores/factor_invoices_store";
import generalFormatter from "../../formatters/general";
import WaitingSpinner from "../../components/waiting_spinner";
import DocumentTitle from "../../components/document_title";
import ReactUtils from "../../react_utils";
import { storeChangedEvent } from "../../stores/object_with_id_store";
import { isJqXHR } from "../../util/fetch";
const bem = ReactUtils.makeBem("debtor-setter");
function initialStateForGroup() {
  return {
    factorBroker: null,
    factorInvoice: {},
    loadingInvoice: true,
    savingInvoice: false,
    noDebtorSelected: null
  };
}
function possibleDebtorPhoneNumber(priOrSec, phoneNumber) {
  if (!_.isEmpty(phoneNumber)) {
    return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("a", { tabIndex: -1, href: "tel:" + phoneNumber, children: [
      priOrSec,
      ": ",
      phoneNumber.replaceAll(" ", "-"),
      " "
    ] }) });
  }
}
function getDebtorEmail(debtor) {
  var _a, _b;
  return (_b = (_a = debtor.cadence_debtor_details.email) != null ? _a : debtor.billing_contact.email) != null ? _b : null;
}
function possibleDebtorEmail(debtor) {
  const possibleEmail = getDebtorEmail(debtor);
  if (possibleEmail != null) return /* @__PURE__ */ jsxs("div", { children: [
    "Email: ",
    possibleEmail
  ] });
  return null;
}
function possibleDebtorNoBuy(debtor) {
  if (debtor.no_buy) {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("i", { className: "fi-alert alert" }),
      "\xA0No Buy"
    ] });
  }
}
function needsDebtor(groupState) {
  return !groupState.factorBroker;
}
function stateForGroup(props, state, groupProps) {
  return state.groups[currentGroupID(props, groupProps)] || initialStateForGroup();
}
function currentGroupID(props, groupProps) {
  if ((groupProps || props).groupID) {
    return (groupProps || props).groupID;
  }
  return "nogroup";
}
function invoiceDate(props, state) {
  if (stateForGroup(props, state)["factorInvoice"]["source_invoice_date"]) {
    return generalFormatter.superShortDate(
      stateForGroup(props, state)["factorInvoice"]["source_invoice_date"]
    );
  } else {
    return "Not found";
  }
}
function groupValue(props, state, value) {
  if (!stateForGroup(props, state).loadingInvoice) {
    return /* @__PURE__ */ jsx("span", { className: "group-value", children: value || "Not found" });
  }
}
function factorInvoiceParams(props, state) {
  return {
    id: factorInvoice(props, state) ? factorInvoice(props, state).id : null,
    factor_broker_id: stateForGroup(props, state).factorBroker ? stateForGroup(props, state).factorBroker.id : null,
    no_debtor_selected: stateForGroup(props, state).noDebtorSelected
  };
}
function factorInvoice(props, state) {
  return stateForGroup(props, state).factorInvoice;
}
function possibleDebtorWarning(props, state) {
  const debtor = stateForGroup(props, state).factorBroker;
  if (debtor && !_.isEmpty(debtor.warning)) {
    return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsxs("div", { className: "factor-invoice__debtor-warning", children: [
      /* @__PURE__ */ jsx("i", { className: "fi-alert alert" }),
      /* @__PURE__ */ jsx("div", { className: "debtor-name", children: debtor.name }),
      /* @__PURE__ */ jsx("div", { className: "debtor-warning", children: debtor.warning })
    ] }) }) });
  }
}
function handleContinue(props, event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }
  props.reloadDocumentBatch().then(() => {
    props.didCompleteGroup();
  });
}
function currentGroupNeedsDebtor(props, state) {
  return needsDebtor(stateForGroup(props, state));
}
function currentDebtor(props, state) {
  return stateForGroup(props, state).factorBroker;
}
function debtorDetails(props, state) {
  const debtor = currentDebtor(props, state);
  if (debtor) {
    return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__compact-address", children: [
      /* @__PURE__ */ jsx(Address, { source: debtor.payment_address, compact: true }),
      possibleDebtorEmail(debtor),
      possibleDebtorNoBuy(debtor),
      possibleDebtorPhoneNumber("Primary", debtor.external_data.Phone1),
      possibleDebtorPhoneNumber("Secondary", debtor.external_data.Phone2)
    ] });
  }
}
class DebtorSetter extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      groups: {}
    });
    __publicField(this, "mounted", false);
    __publicField(this, "setStateForGroup", (values, props, callback) => {
      if (this.mounted) {
        var newState = this.state;
        var currentState = newState.groups[currentGroupID(this.props, props)] || initialStateForGroup();
        newState.groups[currentGroupID(this.props, props)] = currentState;
        _.extend(currentState, values);
        this.setState(newState, callback);
      }
    });
    __publicField(this, "updateFromRemote", (data, props) => {
      stateForGroup(this.props, this.state, props);
      var newState = {
        factorInvoice: data.factor_invoice,
        factorBroker: data.factor_broker,
        loadingInvoice: false,
        savingInvoice: false,
        noDebtorSelected: data.factor_invoice.data["no_debtor_selected"]
      };
      this.setStateForGroup(newState, props || this.state.props);
    });
    __publicField(this, "loadDataForCurrentGroup", (props) => {
      const invoiceId = props.factorInvoiceId;
      FactorInvoicesService.fetchInvoiceAndRelated(invoiceId).then(
        ({ factorInvoice: factorInvoice2 }) => {
          this.fetchDebtorAndUpdate(
            factorInvoice2.factor_broker_id,
            factorInvoice2,
            props
          );
        },
        _.identity
      );
    });
    __publicField(this, "fetchDebtorAndUpdate", (factorBrokerId, factorInvoice2, props) => {
      FactorBrokersService.getWithId(factorBrokerId).then((factorBroker) => {
        this.updateFromRemote(
          {
            factor_invoice: factorInvoice2,
            factor_broker: factorBroker
          },
          props
        );
      }, _.identity);
    });
    __publicField(this, "invoiceStoreUpdated", () => {
      if (this.mounted && factorInvoice(this.props, this.state) && factorInvoice(this.props, this.state).id) {
        const updatedInvoice = FactorInvoicesStore.find(
          factorInvoice(this.props, this.state).id
        );
        if (updatedInvoice.updated_at != factorInvoice(this.props, this.state).updated_at) {
          var fakeData = {
            factor_invoice: updatedInvoice,
            factor_broker: stateForGroup(this.props, this.state).factorBroker
          };
          this.updateFromRemote(fakeData, this.props);
        }
      }
    });
    __publicField(this, "assignDebtorForm", () => {
      return /* @__PURE__ */ jsx(
        WaitingSpinner,
        {
          when: stateForGroup(this.props, this.state).loadingInvoice,
          children: factorInvoice(this.props, this.state) ? /* @__PURE__ */ jsx("div", { className: bem("__choice"), children: /* @__PURE__ */ jsxs("form", { onSubmit: (event) => handleContinue(this.props, event), children: [
            this.loadInformationFields(),
            /* @__PURE__ */ jsxs("div", { className: bem("__actions"), children: [
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: this.handleNoDebtorButtonClicked,
                  className: "debtor-setter__no_debtor_available",
                  children: "No debtor available"
                }
              ),
              /* @__PURE__ */ jsx(
                "button",
                {
                  disabled: currentGroupNeedsDebtor(this.props, this.state) || stateForGroup(this.props, this.state).savingInvoice || stateForGroup(this.props, this.state).loadingInvoice,
                  className: "debtor-setter__submit",
                  children: "Continue"
                }
              )
            ] })
          ] }) }) : /* @__PURE__ */ jsx("div", {})
        }
      );
    });
    __publicField(this, "loadInformationFields", () => {
      var carrier = this.state.carrier;
      var silo = carrier && carrier.silo;
      return /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
        /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("div", { className: bem("__typeahead-label"), children: /* @__PURE__ */ jsx("label", { children: "Debtor" }) }),
            /* @__PURE__ */ jsx(
              DebtorTypeAhead,
              {
                onSelectDebtor: this.debtorSelected,
                autoFocus: true,
                readOnly: false,
                onClearDebtor: this.debtorCleared,
                silo,
                factorBroker: stateForGroup(this.props, this.state).factorBroker
              }
            ),
            /* @__PURE__ */ jsx("br", {})
          ] }),
          currentDebtor(this.props, this.state) ? /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Debtor Details" }),
            debtorDetails(this.props, this.state)
          ] }) : null
        ] }),
        possibleDebtorWarning(this.props, this.state),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
            /* @__PURE__ */ jsx("span", { className: "group-field", children: "Load ID:" }),
            groupValue(
              this.props,
              this.state,
              stateForGroup(this.props, this.state)["factorInvoice"]["load_id"]
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
            /* @__PURE__ */ jsx("span", { className: "group-field", children: "Invoice Number:" }),
            groupValue(
              this.props,
              this.state,
              stateForGroup(this.props, this.state)["factorInvoice"]["source_invoice_number"]
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
            /* @__PURE__ */ jsx("span", { className: "group-field", children: "Date:" }),
            groupValue(
              this.props,
              this.state,
              invoiceDate(this.props, this.state)
            )
          ] })
        ] })
      ] });
    });
    __publicField(this, "saveInvoice", (callback = null) => {
      if (!factorInvoice(this.props, this.state)) return;
      var props = this.props;
      const params = {
        factor_invoice: factorInvoiceParams(this.props, this.state)
      };
      this.setStateForGroup({ savingInvoice: true });
      return Api.FactorInvoices.create(params).then((data) => {
        this.updateFromRemote(data, props);
        if (callback) {
          callback();
        }
      }).catch((e) => {
        const updatedState = _.tap({ savingInvoice: false }, (state) => {
          const errorFields = _.chain(
            isJqXHR(e) && e.responseJSON && e.responseJSON.errors || []
          ).pluck("field").compact().value();
          if (errorFields.includes("source_invoice_amount")) {
            state.source_invoice_amount = null;
          }
        });
        this.setStateForGroup(updatedState, props, this.forceUpdate);
      });
    });
    __publicField(this, "debtorSelected", (factorBroker) => {
      this.setStateForGroup(
        { factorBroker, noDebtorSelected: false },
        null,
        () => {
          this.saveInvoice();
        }
      );
    });
    __publicField(this, "debtorCleared", () => {
      if (stateForGroup(this.props, this.state).loadingInvoice || stateForGroup(this.props, this.state).savingInvoice) {
        return;
      }
      this.setStateForGroup({ factorBroker: null }, null, () => {
        this.saveInvoice();
      });
    });
    __publicField(this, "handleNoDebtorButtonClicked", (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.setStateForGroup(
        { factorBroker: null, noDebtorSelected: true },
        null,
        () => {
          this.saveInvoice(() => handleContinue(this.props));
        }
      );
    });
  }
  componentDidMount() {
    this.mounted = true;
    $(FactorInvoicesStore).on(
      storeChangedEvent("FactorInvoices"),
      this.invoiceStoreUpdated
    );
    this.loadDataForCurrentGroup(this.props);
  }
  componentWillUnmount() {
    this.mounted = false;
    $(FactorInvoicesStore).off(
      storeChangedEvent("FactorInvoices"),
      this.invoiceStoreUpdated
    );
  }
  componentDidUpdate(prevProps) {
    if (prevProps.groupID != this.props.groupID) {
      this.loadDataForCurrentGroup(this.props);
    }
  }
  render() {
    return /* @__PURE__ */ jsx(
      DocumentTitle,
      {
        "data-component": "DebtorSetter",
        title: "TriumphPay Audit \u2013 Assign Debtor",
        children: /* @__PURE__ */ jsxs("div", { className: bem(""), children: [
          /* @__PURE__ */ jsx("h3", { children: `Assign Debtor for Group ${this.props.groupNumber}` }),
          /* @__PURE__ */ jsx("hr", {}),
          this.assignDebtorForm()
        ] })
      }
    );
  }
}
export default DebtorSetter;
